import React from 'react';
import { DocumentAnalyzeEmptyState } from './DocumentAnalyzeEmptyState';
import { CharactersEmptyIllustration } from './empty-illustration';

interface CharactersEmptyStateProps {
  canEdit: boolean;
  onAdd: () => void;
  onAnalyze: () => void;
  isAnalyzing: boolean;
  analyzeDisabled: boolean;
  analyzeTooltip?: string;
}

export const CharactersEmptyState: React.FC<CharactersEmptyStateProps> = ({
  canEdit,
  onAdd,
  onAnalyze,
  isAnalyzing,
  analyzeDisabled,
  analyzeTooltip,
}) => {
  return (
    <DocumentAnalyzeEmptyState
      illustration={<CharactersEmptyIllustration />}
      titleKey="characters_empty_title"
      descriptionKey="characters_empty_description"
      addLabelKey="add_character"
      analyzeLabelKey="analyze_characters_from_document"
      canEdit={canEdit}
      onAdd={onAdd}
      onAnalyze={onAnalyze}
      isAnalyzing={isAnalyzing}
      analyzeDisabled={analyzeDisabled}
      analyzeTooltip={analyzeTooltip}
    />
  );
};
